/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/no-unescaped-entities */
import React, { useState } from 'react';
import { putAccessToken } from '../../utils/api';
import { SuccessModal } from '../layouts/successModal';
import { DynamicModal } from '../layouts/dynamicModal';
import { PhoneNumberModal } from './phone-number';

import * as constants from '../../utils/constant';

import { isNumberOnly } from '../../utils/index';

import {
  SUCCESS,
  OK,
  CONTACT_INFO_SAVED,
  PHONE_NUMBER_SAVED,
} from '../../utils/constant';

import { sharedLibrary } from '../../shared-library.config';
import { PHONE_VERIFICATION_FLOW } from '../../types/online-forms.types';

export function PhoneVerification({
  handleEditContactClose,
  openEditContact,
  openPhoneNumber,
  setopenPhoneNumber,
  setCpStatus,
  allContactNumber,
  setShowPaperlessAlert,
  phoneType,
  setPhoneType,
  phoneDescription,
  setPhoneDescription,
  alertModalPreSelectedValue,
  setAlertModalPreSelectedValue,
  setTextMessage,
  subscribePhoneSer,
  setSubscribePhoneSer,
  contactDataLoading,
  getContactDetails,
  contactData,
  showDiffEmailBtn,
  textMessage,
  allContactNumberValue,
  email,
}: PHONE_VERIFICATION_FLOW) {
  const [contactInfoSuccess, setContactInfoSuccess] = useState<boolean>(false);
  const [apiFailure, setApiFailure] = useState<boolean>(false);

  const [updateContactLoading, setUpdateContactLoading] =
    useState<boolean>(false);

  const config = sharedLibrary.getConfig();
  const highmarkURL = config.HIGHMARK_API_URL;
  const contactInfoURL = `${highmarkURL}/digital/v1/members/contact-information/contacts`;

  const closeContactInfoSuccess = () => {
    setContactInfoSuccess(false);
    if (handleEditContactClose !== undefined) handleEditContactClose();
  };

  const handlePhonClose = () => {
    if (!allContactNumber?.textPhone) setTextMessage(false);

    setopenPhoneNumber(false);
    if (handleEditContactClose !== undefined) handleEditContactClose();
  };

  const closeAPIFailureModal = () => {
    setApiFailure(false);
  };

  const handleClosePhoneNumSuccess = () => {
    setSubscribePhoneSer(false);
  };

  const updateContactData = (phone: string, type: string) => {
    const updateObj = {
      memberDetail: {
        umi: contactData[0]?.umi,
        pin: contactData[0]?.pin,
        firstName: contactData[0]?.firstName,
        middleName: contactData[0]?.middleName,
        lastName: contactData[0]?.lastName,
        birthDate: contactData[0]?.birthDate,
        gender: contactData[0]?.gender,
        ethnicity: contactData[0]?.ethnicity,
        groupNumber: contactData[0]?.groupNumber
          ? contactData[0]?.groupNumber
          : localStorage.getItem('groupNumber'),
        bpdId: contactData[0]?.bpdId,
        addressData: contactData[0]?.addressData,
      },
      // contactPoints: [
      //   {
      //     type: ['Mobile'].includes(type.split(' ')[0]) ? 'Text' : 'Phone',
      //     use: type.split(' ')[0],
      //     value: isNumberOnly(phone),
      //   }
      // ],

      contactPoints: [
        {
          type: 'Email',
          use: 'Member Supplied',
          value: email,
        },
        {
          type: 'Phone',
          use: 'Home',
          value: ['Home'].includes(type.split(' ')[0])
            ? isNumberOnly(phone)
            : allContactNumberValue?.homePhone,
        },
        {
          type: 'Phone',
          use: 'Work',
          value: ['Work'].includes(type.split(' ')[0])
            ? isNumberOnly(phone)
            : allContactNumberValue?.workPhone,
        },
        {
          type: 'Text',
          use: 'Mobile',
          value: ['Mobile Phone', 'Text Message', 'Mobile'].includes(type)
            ? isNumberOnly(phone)
            : allContactNumberValue?.textPhone,
        },
      ],
    };
    if (phone) {
      setUpdateContactLoading(true);
      putAccessToken(contactInfoURL, updateObj, '').then((result: any) => {
        setUpdateContactLoading(false);

        setCpStatus((prevState: any) => ({
          ...prevState,
          [alertModalPreSelectedValue.key]: alertModalPreSelectedValue.value,
        }));

        if (result?.memberContactsResponse) {
          setopenPhoneNumber(false);

          if (openEditContact) {
            if (handleEditContactClose !== undefined) handleEditContactClose();
          }

          if (
            ['Mobile Phone', 'Text Message', 'Mobile'].includes(type) &&
            textMessage
          ) {
            setSubscribePhoneSer(true);
          } else {
            setContactInfoSuccess(true);
          }

          getContactDetails(contactInfoURL, '');

          setAlertModalPreSelectedValue({
            key: '',
            value: '',
          });
        }

        if (result.errMsg) {
          setApiFailure(true);
          setAlertModalPreSelectedValue({
            key: '',
            value: '',
          });
        }
      });
    }
  };

  const handleAlertModalOkBtn = () => {
    setCpStatus((prevState: any) => ({
      ...prevState,
      [alertModalPreSelectedValue.key]: alertModalPreSelectedValue.value,
    }));
    setShowPaperlessAlert(false);
    if (
      (alertModalPreSelectedValue.value === 'Mobile Phone' &&
        !allContactNumber.mobilePhone) ||
      (alertModalPreSelectedValue.value === 'Work Phone' &&
        !allContactNumber.workPhone) ||
      (alertModalPreSelectedValue.value === 'Home Phone' &&
        !allContactNumber.homePhone)
    ) {
      setopenPhoneNumber(true);

      setPhoneType(alertModalPreSelectedValue.value);

      if (alertModalPreSelectedValue.value === 'Mobile Phone') {
        setPhoneDescription(constants.MOBILE_PHONE_DESCRIPTION);
      } else if (alertModalPreSelectedValue.value === 'Work Phone') {
        setPhoneDescription(constants.WORK_PHONE_DESCRIPTION);
      } else if (alertModalPreSelectedValue.value === 'Home Phone') {
        setPhoneDescription(constants.HOME_PHONE_DESCRIPTION);
      }
    }
    setAlertModalPreSelectedValue({
      key: '',
      value: '',
    });
  };

  return (
    <>
      <SuccessModal
        open={contactInfoSuccess}
        onClose={closeContactInfoSuccess}
        heading={SUCCESS}
        description={CONTACT_INFO_SAVED}
        btnText={OK}
      />
      <SuccessModal
        open={subscribePhoneSer}
        onClose={handleClosePhoneNumSuccess}
        heading={SUCCESS}
        description={PHONE_NUMBER_SAVED}
        btnText={OK}
      />

      {apiFailure && (
        <DynamicModal
          open={apiFailure}
          type="API_FAILED"
          heading={constants.API_FAILED_TITLE}
          description={constants.API_FAILED_CONTENT}
          description2={constants.API_FAILED_CONTENTSECOND}
          saveBtn={constants.OK}
          cancelBtn={constants.CANCEL_BTN}
          onClose={closeAPIFailureModal}
          saveBtnHandler={handleAlertModalOkBtn}
        />
      )}

      {openPhoneNumber && (
        <PhoneNumberModal
          open={openPhoneNumber}
          onClose={handlePhonClose}
          heading={constants.ATTENTION}
          type={phoneType}
          description={phoneDescription}
          showDiffEmailBtn={showDiffEmailBtn}
          saveBtn={constants.PHONE_SAVE_BTN}
          cancelBtn={constants.CANCEL_BTN}
          handleEditContactClose={handleEditContactClose}
          updateContactData={updateContactData}
          updateContactLoading={updateContactLoading}
          contactDataLoading={contactDataLoading}
          allContactNumberValue={allContactNumberValue}
        />
      )}
    </>
  );
}
